import { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import { fetchDataLogin } from "verticales/FetchData";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import BasicLayout from "login/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import bgImage2 from "login/Logo2.png";
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";

// const clientId = "716269390985-54fg9kuk4ov7upip3nn1u975spt7hphf.apps.googleusercontent.com";
const clientId = "716269390985-nrcgg6tk8tnf5fsuj0pnin1emv2s3t0g.apps.googleusercontent.com";
function Basic() {
  const [triggerOneTabLogin, setTriggerOneTabLogin] = useState(false);
  const navigate = useNavigate();

  const onSuccessGoogle = async (respCredential) => {
    console.log("respCredential........", respCredential);
    localStorage.setItem("accessTokenG", respCredential.credential);
    localStorage.setItem("id_token", respCredential.credential);
    const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/";
    const resp = await fetchDataLogin(url, "login", { action: "login" });
    console.log("resp...", resp);
    if (resp && resp.statusLogin == "ok") {
      console.log("paso1");
      navigate("/");
    } else {
      console.log("paso2");
      // aunque el login es valido para google no tiene accesos a DS Siesa
      // error numero 2
    }
  };

  const onErrorGoogle = () => {
    console.log("Login Failed");
  };

  const handleOneTabLogin = () => {
    setTriggerOneTabLogin(!triggerOneTabLogin);
  };

  return (
    <BasicLayout image={bgImage}>
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker label="Basic date time picker" />
        </DemoContainer>
      </LocalizationProvider> */}
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign into POS1
          </MDTypography>
          {/* <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid> */}
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            {/* <MDBox mb={2}>
              <MDInput type="email" label="Email" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Password" fullWidth />
            </MDBox> */}
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me  onClick={async () => {
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={() => handleOneTabLogin()}
              >
                google
              </MDButton>
            </MDBox>
            {/* <MDBox mt={4} mb={1}>
              <Button color="primary" fullWidth onClick={handleOneTabLogin}>
                sign in
              </Button>
            </MDBox> */}
            {/* <MDBox mt={4} mb={1}>
              <GoogleOAuthProvider clientId={clientId}>
                <GoogleLogin
                  onSuccess={(credentialResponse) => onSuccessGoogle(credentialResponse)}
                  onError={() => onErrorGoogle}
                  useOneTap
                  //auto_select
                />
              </GoogleOAuthProvider>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              {triggerOneTabLogin ? (
                <GoogleOAuthProvider clientId={clientId}>
                  <AppGoogleOneTapLogin
                    onSuccessGoogle={onSuccessGoogle}
                    onErrorGoogle={onErrorGoogle}
                  />
                </GoogleOAuthProvider>
              ) : (
                <AppNone />
              )}
            </MDBox>
            {/* <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

function AppGoogleOneTapLogin(props: any) {
  // Configuramos el inicio de sesión de Google One Tap
  useGoogleOneTapLogin({
    onSuccess: props.onSuccessGoogle,
    onError: props.onErrorGoogle,
    prompt: "consent",
  });

  return (
    <div>
      <p> </p>
    </div>
  );
}

function AppNone() {
  return (
    <div>
      <p> </p>
    </div>
  );
}

export default Basic;
